<div class="bciti-table">
  <table
    class="table"
    #serviceTable
    mat-table
    matSort
    [dataSource]="dataSource"
    (matSortChange)="onSortChange($event)"
  >

    <!-- Color -->
    <ng-container matColumnDef="color">
      <th class="table-header" mat-header-cell *matHeaderCellDef></th>
      <td class="table-cell table-color" mat-cell *matCellDef="let element">
        <span [style.background-color]="element.color" [ngStyle]="getShapeStyle(element.minifiedShape)">
        </span>
      </td>
    </ng-container>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th class="table-header" mat-header-cell *matHeaderCellDef></th>
      <td class="table-cell table-icon" mat-cell *matCellDef="let element">
        <span [ngClass]="element.icon"></span>
      </td>
    </ng-container>

    <!-- Collection name -->
    <ng-container matColumnDef="name">
      <th class="table-header" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'pages.collections.list.table.header.collectionName' | translate }}
        <mat-icon class="sort-icon">{{ getSortIcon('name') }}</mat-icon>
      </th>
      <td class="table-name" mat-cell *matCellDef="let element" (click)="handleClick('edit', element)">
          <span>{{ element.name[translate.currentLang] }}</span>
      </td>
    </ng-container>

    <!-- Areas -->
    <ng-container matColumnDef="areas">
      <th class="table-header" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'pages.collections.list.table.header.areas' | translate }}
        <mat-icon class="sort-icon">{{ getSortIcon('areas') }}</mat-icon>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngFor="let area of element.areas; let i = index">
        {{ area?.name }}<span *ngIf="i !== element.areas?.length - 1">, </span>
        </ng-container>
      </td>
    </ng-container>

      <!-- Days -->
      <ng-container matColumnDef="days">
        <th class="table-header" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pages.collections.list.table.header.days' | translate }}
          <mat-icon class="sort-icon">{{ getSortIcon('days') }}</mat-icon>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.schedules">
            <ng-container *ngFor="let day of element.schedules[0]?.days; let i = index">
              {{ 'pages.collections.days.' + day | translate }}<span *ngIf="i !== element.schedules[0].days.length - 1">, </span>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>

      <!-- Frequency -->
      <ng-container matColumnDef="frequency">
        <th class="table-header" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'pages.collections.list.table.header.frequency' | translate }}
          <mat-icon class="sort-icon">{{ getSortIcon('frequency') }}</mat-icon>
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.schedules[0]?.frequency">
            {{ 'pages.collections.frequency.' + element.schedules[0]?.frequency | translate }}
          </ng-container>
        </td>
      </ng-container>

    <!-- Action -->
    <ng-container matColumnDef="action">
      <th class="table-header" mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element" class="action-col">
        <button 
          class="desktop-table-button bciti-button bciti-button--invisible" 
          aria-label="Open"
          [matMenuTriggerFor]="actionMenu"
        >
          <i class="icon-more-vertical"></i>
        </button>
        <mat-menu 
          #actionMenu="matMenu" 
          class="bciti-table-dropdown bciti-table-dropdown--actions" 
          xPosition="before"
        >
          <button 
            mat-menu-item
            *ngFor="let item of actionMenuOptions"
            class="bciti-table-dropdown-option bciti-table-dropdown-option--actions"
            (click)="handleClick(item.eventEmitterTag, element)"
          >
            <span>{{ item.label }}</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnKeys"></tr>
    <tr  *matRowDef="let row; columns: columnKeys; let rowIndex = index"  mat-row></tr>

    <tr class="mat-row" *matNoDataRow>
      <td
        class="mat-cell"
        [attr.colspan]="columnKeys.length"
      >
        <div class="empty-table-cell-content">
          <mat-progress-spinner
            *ngIf="loading"
            mode="indeterminate" 
            diameter="20"
          ></mat-progress-spinner>
          <span *ngIf="!loading">
            No collections
          </span>
        </div>
      </td>
    </tr>

  </table>

  <mat-paginator 
    class="paginator"
    showFirstLastButtons 
    [length]="dataSource.data.length"
    [pageSizeOptions]="[5, 10, 25, 50]" 
    [pageSize]="10"
  ></mat-paginator>
</div>